import { render, staticRenderFns } from "./WorkspaceDeviceParamForm.vue?vue&type=template&id=87a9f5c2"
import script from "./WorkspaceDeviceParamForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceDeviceParamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports